const config = {
	chef: {
		INDUSTRY_ID: 3874,
		SUB_INDUSTRY_ID: 68246
	},
	barista: {
		INDUSTRY_ID: 3875,
		SUB_INDUSTRY_ID: 68243
	},
	runner: {
		INDUSTRY_ID: 3875,
		SUB_INDUSTRY_ID: 68244
	},
	manager: {
		INDUSTRY_ID: 3876,
		SUB_INDUSTRY_ID: null
	},
	HOST_NAME: 'genesis.recsite.com', // API
	PROTOCOL: 'https',
	DOMAIN: 'genesis.recsite.com'
};
export default config;


// WEBPACK FOOTER //
// ./src/config/constants.js